export default __webpack_public_path__ + "static/media/logoicon.b76f4b59.PNG";